Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var core = require('@material-ui/core');
var dateFns = require('date-fns');
var clsx = require('clsx');
var moment = require('moment');
var antd = require('antd');
require('antd/dist/antd.css');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var useStyles = core.makeStyles(function () {
  return {
    root: {
      border: 0,
      margin: 0,
      display: "inline-flex",
      padding: 0,
      position: "relative",
      minWidth: 0,
      flexDirection: "column",
      verticalAlign: "top",
      width: "100%"
    },
    label: {
      color: "#546e7a",
      padding: 0,
      fontSize: "1rem",
      fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
      fontWeight: 400,
      lineHeight: 1,
      letterSpacing: "0.00938em",
      top: 0,
      left: 0,
      position: "absolute",
      transform: "translate(14px, -6px) scale(0.75)",
      transformOrigin: "top left"
    },
    container: {
      color: "#263238",
      cursor: "text",
      display: "inline-flex",
      position: "relative",
      fontSize: "1rem",
      boxSizing: "border-box",
      alignItems: "center",
      fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
      fontWeight: 400,
      lineHeight: "1.1876em",
      letterSpacing: "0.00938em",
      borderRadius: "4px",
      padding: 0,
      "& input": {
        font: "inherit",
        color: "currentColor",
        width: "100%",
        border: 0,
        height: "1.1876em",
        margin: 0,
        display: "block",
        minWidth: 0,
        background: "none",
        boxSizing: "content-box",
        animationName: "mui-auto-fill-cancel",
        letterSpacing: "inherit",
        animationDuration: "10ms",
        padding: "18.5px 14px",
        borderRadius: "4px",
        "&:focus": {
          outline: "none",
          border: 0
        }
      }
    },
    fieldset: {
      top: "-5px",
      left: 0,
      right: 0,
      bottom: 0,
      margin: 0,
      padding: "0 8px",
      overflow: "hidden",
      position: "absolute",
      borderStyle: "solid",
      borderWidth: "1px",
      borderRadius: "4px",
      pointerEvents: "none",
      borderColor: "rgba(0, 0, 0, 0.23)"
    },
    legend: {
      width: "auto",
      height: "11px",
      display: "block",
      padding: 0,
      fontSize: "0.75em",
      textAlign: "left",
      visibility: "hidden",
      maxWidth: "1000px",
      transition: "max-width 100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms",
      "& > span": {
        display: "inline-block",
        paddingLeft: "5px",
        paddingRight: "5px"
      }
    },
    popup: {
      zIndex: 999999,
      "&.ant-picker-dropdown": {
        zIndex: 999999
      },
      "& .ant-picker-footer": {
        display: "none"
      },
      "& .ant-picker-time-panel": {
        padding: 0,
        "& .ant-picker-content": {
          minWidth: "112px",
          display: "flex",
          flex: "auto",
          height: "224px"
        }
      },
      "& .ant-picker-time-panel-column": {
        "-ms-overflow-style": "none" /* IE and Edge */,
        "scrollbar-width": "none" /* Firefox */,
        backgroundColor: "#fff",
        flex: "1 0 auto",
        width: "calc(50% + 17px)",
        margin: 0,
        padding: 0,
        overflowY: "scroll",
        textAlign: "left",
        listStyle: "none",
        transition: "background .3s",
        paddingRight: "17px",
        "&:not(:first-child)": {
          overflowY: "unset",
          width: "50%",
          alignSelf: "flex-start",
          marginLeft: "-17px",
          borderLeft: "1px solid #f0f0f0",
          paddingRight: 0
        },
        "&::-webkit-scrollbar": {
          display: "none"
        },
        "& .ant-picker-time-panel-cell": {
          fontSize: "1rem",
          fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
          fontWeight: 400,
          lineHeight: "2rem",
          height: "2rem",
          letterSpacing: "0.01rem",
          border: "2px solid transparent",
          "&:focus, &:hover": {
            border: "2px solid #0956a2",
            backgroundColor: "transparent"
          },
          "& .ant-picker-time-panel-cell-inner": {
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          "&.ant-picker-time-panel-cell-selected": {
            border: "2px solid #0D73D9",
            "&:focus, &:hover": {
              border: "2px solid #0956a2",
              backgroundColor: "#0D73D9"
            },
            "& .ant-picker-time-panel-cell-inner": {
              backgroundColor: "#0D73D9",
              color: "#FFFFFF"
            }
          }
        }
      }
    },
    focusedBorder: {
      borderWidth: "2px",
      borderColor: "#0D73D9"
    },
    focusedText: {
      color: "#0D73D9"
    },
    suffixIconContainer: {
      padding: "0.75rem"
    },
    invalidBorder: {
      borderColor: "#f44336"
    },
    invalidText: {
      color: "#f44336"
    },
    helperText: {
      marginLeft: "14px",
      marginRight: "14px",
      margin: 0,
      fontSize: "0.75rem",
      marginTop: "3px",
      textAlign: "left",
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      lineHeight: 1.66,
      letterSpacing: "0.03333em"
    },
    invalidHelperText: {
      color: "#f44336"
    }
  };
});
var TimePicker = function TimePicker(_a) {
  var name = _a.name,
    label = _a.label,
    value = _a.value,
    disabled = _a.disabled,
    minutesStep = _a.minutesStep,
    inputDataTest = _a.inputDataTest,
    icon = _a.icon,
    helperText = _a.helperText,
    _b = _a.onChange,
    _onChange = _b === void 0 ? function () {} : _b,
    _c = _a.onClick,
    onClick = _c === void 0 ? function () {} : _c,
    _d = _a.isValid,
    isValid = _d === void 0 ? true : _d;
  var classes = useStyles();
  var _e = React.useState(false),
    isFocused = _e[0],
    setIsFocused = _e[1];
  return React__default['default'].createElement(React__default['default'].Fragment, null, React__default['default'].createElement("div", {
    className: classes.root
  }, label && React__default['default'].createElement("label", {
    className: clsx__default['default'](classes.label, isFocused && classes.focusedText, !isValid && classes.invalidText)
  }, label), React__default['default'].createElement(antd.TimePicker, {
    name: name,
    disabled: disabled,
    showSecond: false,
    value: moment__default['default'](value || dateFns.setMinutes(new Date(), 0)),
    className: classes.container,
    onSelect: function onSelect(value) {
      _onChange(value === null || value === void 0 ? void 0 : value.toDate());
    },
    onChange: function onChange(value) {
      var val = value;
      if (val.minute() !== 0 && val.minute() !== 15 && val.minute() !== 30 && val.minute() !== 45) {
        var m = Math.floor((val.minute() + 7.5) / 15) * 15;
        val.minute(m);
      }
      _onChange(val === null || val === void 0 ? void 0 : val.toDate());
    },
    onClick: onClick,
    minuteStep: minutesStep,
    popupClassName: classes.popup,
    suffixIcon: React__default['default'].createElement("div", {
      className: classes.suffixIconContainer
    }, icon),
    format: "HH:mm",
    showNow: false,
    bordered: false,
    clearIcon: React__default['default'].createElement(React__default['default'].Fragment, null),
    "data-test": inputDataTest || "testietest",
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    }
  }), label && React__default['default'].createElement("fieldset", {
    className: clsx__default['default'](classes.fieldset, isFocused && classes.focusedBorder, !isValid && classes.invalidBorder)
  }, React__default['default'].createElement("legend", {
    className: classes.legend
  }, React__default['default'].createElement("span", null, label)))), helperText && React__default['default'].createElement("span", {
    className: clsx__default['default'](classes.helperText, !isValid && classes.invalidHelperText)
  }, helperText));
};
exports.default = TimePicker;